module.exports = __webpack_public_path__ + "img/SOWTA_Deep_1k.4ca626b4.png";